export const SHARE_RESUME_SUCCESS = 'SHARE_RESUME_SUCCESS';
export const SHARE_RESUME_START = 'SHARE_RESUME_START';
export const SHARE_RESUME_ERROR = 'SHARE_RESUME_ERROR';
export const SHARE_IDEA_START = 'SHARE_IDEA_START';
export const SHARE_IDEA_SUCCESS = 'SHARE_IDEA_SUCCESS';
export const SHARE_IDEA_ERROR = 'SHARE_IDEA_ERROR';
export const SHARE_TO_GROUP_START = 'SHARE_TO_GROUP_START';
export const SHARE_TO_GROUP_SUCCESS = 'SHARE_TO_GROUP_SUCCESS';
export const SHARE_TO_GROUP_ERROR = 'SHARE_TO_GROUP_ERROR';